// fill in both in order to get proper intellisense
export type BaseDict = {
    Live: string,
    LiveStream: string,
    Statistics: string,
    FastMarket: string,
    PulseBet: string,
    NoEvents: string,
    SortBy: string,
    League: string,
    Time: string,
    NextUp: string,
    ViewAllLink: string,
    ViewAllBtn: string,
    Favorites: string,
    ViewAllOutrights: string,
    AllEventsInFavorites: string,
    EachWayTag: string,
    Home: string,
    Draw: string,
    Away: string,
    Tie: string,
    HideAllOdds: string,
    ShowAllOdds: string
    "1_39": string,
    "2_39": string,
    "3_39": string,
    "3_714": string,
    TwoBox_1_39_1: string,
    TwoBox_1_39_2: string,
    PointBox_3_714_1: string,
    PointBox_3_714_2: string,
    PointBox_3_714_3: string,
    "day-0": string,
    "day-1": string,
    "day-2": string,
    "day-3": string,
    "day-4": string,
    "day-5": string,
    "day-6": string,
   "month-0": string,
   "month-1": string,
   "month-2": string,
   "month-3": string,
   "month-4": string,
   "month-5": string,
   "month-6": string,
   "month-7": string,
   "month-8": string,
   "month-9": string,
   "month-10": string,
   "month-11": string,
   AmericanBtnOver: string,
   AmericanBtnUnder: string
   AmericanBtnMLHome: string,
   AmericanBtnMLAway: string,
   AmericanBtnMLDraw: string,
   AmericanBtnMLTie: string,
   StartedAt: string,
   StartsIn: string,
   ClockMins: string
}
export const BaseDict: BaseDict = {
    Live: "Live",
    LiveStream: "LiveStream available!",
    Statistics: "Statistics available!",
    FastMarket: "FastMarket available!",
    PulseBet: "PulseBet available!",
    NoEvents: "No events were found",
    SortBy: "Sort by",
    League: "League",
    Time: "Time",
    NextUp: "Next up",
    ViewAllLink: "Go to leagues view",
    ViewAllBtn: "View All",
    ViewAllOutrights: "View All Outrights",
    Favorites: "Favorites",
    AllEventsInFavorites: "All events are moved to Favorites",
    EachWayTag: "EW",
    Home: "1",
    Draw: "X",
    Away: "2",
    Tie: "X",
    HideAllOdds: "Hide All Odds",
    ShowAllOdds: "Show All Odds",
    "1_39": "MoneyLine",
    "2_39": "Spread",
    "3_39": "Over/Under",
    "3_714": "O/U",
    TwoBox_1_39_1: "1",
    TwoBox_1_39_2: "2",
    PointBox_3_714_1: "Points",
    PointBox_3_714_2: "Over",
    PointBox_3_714_3: "Under",
    "day-0": "Monday",
    "day-1": "Tuesday",
    "day-2": "Wednesdat",
    "day-3": "Thursday",
    "day-4": "Friday",
    "day-5": "Saturday",
    "day-6": "Sunday",
    "month-0": "January",
    "month-1": "February",
    "month-2": "March",
    "month-3": "April",
    "month-4": "May",
    "month-5": "June",
    "month-6": "July",
    "month-7": "August",
    "month-8": "September",
    "month-9": "October",
    "month-10": "November",
    "month-11": "December",
    AmericanBtnOver: "O",
    AmericanBtnUnder: "U",
    AmericanBtnMLHome: "1",
    AmericanBtnMLAway: "2",
    AmericanBtnMLDraw: "X",
    AmericanBtnMLTie: "X",
    StartedAt: "Starts At",
    StartsIn: "Starts in",
    ClockMins: "{0}'"
}